import { useLayoutEffect } from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { PageHeader } from "../components/PageHeader";
import {
  ContentArea,
  InPersonSessionImage,
  SessionPageContainer,
  IntroArea,
  IntroTextContainer,
  SessionImageContainer,
  SubTitle,
} from "../components/SessionPageComponents";
import { ladders } from "../data/Ladder";
import { LadderTile } from "../components/LadderTile";
import { DescentPageCtaSection } from "../components/DescentApplicationCta";
import { DescentFaqSection } from "../components/DescentFaqSection";

import RedBullwhipImage from "../assets/gallery/redBullwhip.jpeg";
import ChokingImage from "../assets/gallery/chocking.jpeg";

export const TheDescentPage = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>The Descent | Maya Mistress</title>
        <meta
          name="description"
          content="The Descent by Maya Mistress. A focused journey into submission, power dynamics, and surrender."
        />
        <meta
          name="keywords"
          content="The Descent, Maya Mistress, FemDom, submission, power dynamics"
        />
      </Helmet>

      <SessionPageContainer>
        <ContentArea>
          <PageHeader title="The Descent" subtitle="Welcome to my Inner Circle" backdropText="Descent" />
          <IntroArea>
            <SessionImageContainer>
              <InPersonSessionImage image={RedBullwhipImage} />
            </SessionImageContainer>
            <IntroTextContainer>
              <SubTitleLeft>The Descent is a Bond</SubTitleLeft>
              <TextContainer>
                Over the years, I have developed ways to keep in touch with a
                few submissives who were special to Me, in-between sessions,
                remotely. That led into some beautiful dynamics where the flame
                and connection were kept alive in between in-person experiences.
                This allowed for a whole new level of depth. Turning them into
                real relationships of Power, Eroticism and Care.
              </TextContainer>
              <br />
              <SubTitleLeft>The Descent is Real</SubTitleLeft>
              <TextContainer>
                I don't perform. I Am. The leash I place on my chosen isn't a
                roleplay that falls apart when the camera goes off. It's an
                alive dynamic. I take pleasure in infiltrating the shape of your
                days, your discipline, your mind and your body. That means that
                the levels described here aren't rigid cages, they are
                containers. Reference points. What actually happens inside each
                of them is always unique, tailored, personal, and between Me and
                you.
              </TextContainer>
              <DesktopRowSpacer />
            </IntroTextContainer>
          </IntroArea>
          <br />
          <IntroArea>
            <IntroTextContainer>
              <SubTitleLeft>The Descent is Absolute</SubTitleLeft>
              <TextContainer>
                You are entitled to nothing but your hard limits. I am entitled
                to you in your entirety. The asymmetry between us is total and
                ultimate. My attention is not taken for granted. My responses
                are not scheduled, AI-generated, delegated or automated. That
                means that whatever I do to you, I do because it was my desire
                to do so. You do not hire me. You submit to me. Take it or leave
                it.
              </TextContainer>
              <br />

              <SubTitleLeft>The Descent is a Privilege</SubTitleLeft>
              <TextContainer>
                Entry is by approval only - either your application, or by my
                invitation. I will assess your sincerity and readiness and
                inform you the maximum depth you may start from. From there, you
                are given the chance of going deeper by consistently pleasing
                Me. Progression is earned, not assumed. My energy and time are
                finite, and belong to Me first. Therefore, so are the slots for
                each level of depth.
              </TextContainer>
              <DesktopRowSpacer />
            </IntroTextContainer>
            <SessionImageContainer>
              <InPersonSessionImage image={ChokingImage} />
            </SessionImageContainer>
          </IntroArea>

          <br />
          <br />
          <SubTitle>How deep can you take?</SubTitle>
          <br />
          {ladders.map((ladder, index) => (
            <LadderTile
              key={ladder.title}
              ladder={ladder}
              index={index}
              total={ladders.length}
              isLast={index === ladders.length - 1}
            />
          ))}

          <DescentFaqSection preview />
          <DescentPageCtaSection />
        </ContentArea>
      </SessionPageContainer>
    </>
  );
};


const SubTitleLeft = styled.h3`
  font-family: "Ysabeau";
  font-weight: 300;
  text-align: center;
  text-transform: uppercase;
  font-size: 1.6rem;
  letter-spacing: 0.2rem;
`;

const DesktopRowSpacer = styled.div`
  display: none;

  @media screen and (min-width: 601px) {
    display: block;
    height: 3rem;
  }
`;

const TextContainer = styled.div``;
